import React, { useState, useEffect } from "react";
import Leftpanel from "../../layout/Leftpanel";
import Header from "../../layout/Header";
import { City, Country, State } from "country-state-city";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Button, Modal } from "react-bootstrap";
import {
  getVat,
  getAllVatlist,
  deleteVat,
  getVatByid,
  getUpdateVat,
  getMyAllVatlist,
  ListCountry,
} from "../../../../service/VAT/VatService";
import Multiselect from "../../Multiselect";
import MultiselectVat from "../../MultiselectVat";
import { useTranslation } from "react-i18next";

const Vat = () => {
  const { t } = useTranslation();
  const [optionsvat, setOptionsvat] = useState([]);
  // const optionsvat = [];
  const [selectedOptions, setSelectedOptions] = useState([]);

  // let countryData = Country.getAllCountries();
  const [myVatList, setMyVatList] = useState([]);
  const [percentage, setPercentage] = useState("");
  const [vatId, setVatId] = useState();
  const [country, setCountry] = useState("");
  const [Editcountry, setEditCountry] = useState("");
  const [allVatList, setAllVatList] = useState([]);
  const [showDelete, setShowDelete] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [countryData, setCountryData] = useState([]);
  const [coutryWiseVatList, setCoutryWiseVatList] = useState([]);

  const [deleteVatId, setDeleteVatId] = useState("");
  const [allData, setAllData] = useState({
    vat: "",
    country: "",
  });

//  console.log(allData, "alldata");

  const handleCloseDelete = () => setShowDelete(false);
  const handleCloseEdit = () => {
    setShowEdit(false);
  };

  const onPercentage = (e) => {
    setPercentage(e.target.value);
  };

  const onEditPercentage = (e) => {
    // setPercentage(e.target.value)
    setAllData({ ...allData, vat: e.target.value });
  };

  const onCountry = (e) => {
    // let a = document.getElementById('')
    // console.log(e.target.value, "evalue");
    // console.log(e.target.innerHTML, "evalue");
    // console.log(e.selectedOptions[0].innerHTML, "dsawe");
    setCountry(JSON.parse(e.target.value).Country);
    setCoutryWiseVatList(JSON.parse(e.target.value).vat);
    // setPercen
    // setPercentage(JSON.parse(e.target.value).vat)
    // setVatId(JSON.parse(e.target.value).id)
  };

  const onEditCountry = (e) => {
    // let a = document.getElementById('')
  //  console.log(e, "evalue");
    // console.log(e.selectedOptions[0].innerHTML, "dsawe");
    setEditCountry(e.target.value);
  };

//  console.log(selectedOptions, "selectedOptions");

  const onAdd = (e) => {
    e.preventDefault();
    // if (country === "") {
    //     toast.error("Please select Country")
    // } else if (percentage === "") {
    //     toast.error("Please type VAT")
    // } else {
    // console.log(country.id,"??")
    // console.log(selectedOptions.map(item=>item.id),"selectedOptionshh")
    getVat(
      country.id,
      coutryWiseVatList.map((item) => item.id),
      (r) => {
        if (r.success === true) {
          setSelectedOptions([]);
          // setCountryData([]);
          getMyVatDataList();
          coutryWiseVatList([]);
          toast.success(r.message);
        } else {
          toast.error(r.message);
          setSelectedOptions([]);
          // setCountryData([]);
          getMyVatDataList();
          coutryWiseVatList([]);
        }
      }
    );
    // }
  };

  //for update or edit button
  const onSave = () => {
    getUpdateVat(
      allData?.id,
      Editcountry ? Editcountry : allData?.country,
      allData?.vat,

      (res) => {
      //  console.log(res, "response");
        if (res.success === true) {
          toast.success(res.message);
          setShowEdit(false);
          setEditCountry("");
          getVatDataList();

          // navigate("/businessunit")
        } else {
        //  console.log("nononononono");
          toast.error(res.message);
        }
      }
    );
  };

  const showAllCountry = async () => {
    ListCountry((res) => {
      // console.log(res.data.vatList)
      setCountryData(res.data.vatList);
    });
  };

  useEffect(() => {
    getVatDataList();
    getMyVatDataList();
    showAllCountry();
  }, []);

  async function getVatDataList() {
    getAllVatlist().then(function (result) {
      const response = result.data;
      setAllVatList(response.data.vatList);
    });
  }

  async function getMyVatDataList() {
    getMyAllVatlist().then(function (result) {
      // const response = result.data.data.vatList;
      // console.log(result.data.data.userVatList,"response")
      setMyVatList(result?.data?.data?.userVatList);
    });
  }

  const onDelete = (data) => {
    // console.log(data,"fffffff")
    setDeleteVatId(data);
    // console.log(data, "datadatadatadatadatadata")
    setShowDelete(true);
  };
  const onEdit = (e) => {
    // console.log(e,"uuu")
    // setDeleteVatId(e);
    getVatByid(Number(e)).then(function (r) {
      const response = r?.data;
      // console.log(response?.data?.vat, "qwaswqas")
      setAllData(response?.data?.vat.Vat);
      // setDepartmentId(response?.data?.businessUnit?.Departments);
    });
  //  console.log(e, "edit");
    setShowEdit(true);
  };
  const onYes = () => {
    deleteVat(deleteVatId, (res) => {
      // console.log(res, "response")
      if (res.success === true) {
        toast.success(res.message);
        setShowDelete(false);
        // getVatDataList();
        getMyVatDataList();
      } else {
        toast.error(res.message);
      }
    });
  };

  const onNo = () => {
    setShowDelete(false);
  };
  return (
    <div className="container-fluid">
      <div className="dbMain vats">
        <Leftpanel breadcm={t("vat")} />
        <div className="dbRight">
          <Header
            link="/dashboard"
            title={`${t("vat")} > ${t("add_vat")}`}
            description=""
          />
          <div className="commonBase mb-4">
            <h5>{t("add_vat")}</h5>
            <div className="vatAdd">
              <select className="form-control" onChange={onCountry}>
                <option selected value="">
                  {t("select_country")}
                </option>
                {countryData.map((item) => (
                  <option value={JSON.stringify(item)} key={item.Country.id}>
                    {item.Country.name}
                  </option>
                ))}
              </select>
              &nbsp;&nbsp;
              <button className="commonButton" onClick={onAdd}>
                <i className="fa-solid fa-plus"></i> {t("add")}
              </button>
            </div>
          </div>
          <div className="commonBase">
            <h5>{t("vat_list")}</h5>
            {myVatList?.map((d) => (
              <div className="vatList" key={d.countryId}>
                <div className="vatListblock firstlist">
                  <span>{t("country")}</span>
                  <h5>{d?.Country?.name}</h5>
                </div>
                <div className="vatListblock">
                  <div>{t("vat")}</div>
                  {d?.vat.length > 0 &&
                    d?.vat?.map((item, index) => (
                      <strong key={index} style={{ display: "block" }}>
                        {item?.vat} %
                      </strong>
                    ))}
                </div>
                <button
                  className="deleteBtn"
                  onClick={onDelete.bind(d?.countryId, `${d?.countryId}`)}
                >
                  <i className="fa-solid fa-trash-can"></i>
                </button>
              </div>
            ))}
          </div>
        </div>

        <Modal show={showDelete} onHide={handleCloseDelete}>
          <Modal.Header closeButton>
            <Modal.Title>{t("delete_confirmation")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Button variant="primary" className="commonButton" onClick={onYes}>
              {t("yes")}
            </Button>
            &nbsp;&nbsp;
            <Button variant="primary" className="commonButton" onClick={onNo}>
              {t("no")}
            </Button>
          </Modal.Body>
        </Modal>

        <Modal show={showEdit} onHide={handleCloseEdit}>
          <Modal.Header closeButton>
            <Modal.Title>{t("edit_vat")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="vatAdd">
              <select
                className="form-control"
                value={Editcountry}
                name="country"
                onChange={onEditCountry}
              >
                {allVatList.map((con) => (
                  <option
                    value={JSON.stringify({
                      vat: con.vat,
                      country: con.country,
                      id: con.id,
                    })}
                    key={con.id}
                  >
                    {con.country}
                  </option>
                ))}
              </select>
              &nbsp;&nbsp;
              <input
                type="Number"
                className="form-control"
                placeholder={t("percentage")}
                value={allData?.vat}
                onChange={onEditPercentage}
                name="vat"
              />
              &nbsp;&nbsp;
              <button className="commonButton" onClick={onSave}>
                {t("save")}
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

export default Vat;
